import React, { Component } from 'react'
import {Button,Image,Spinner} from 'react-bootstrap';
import Chart from '../components/Chart'
import PortfolioRow from '../components/PortfolioRow'
// import TurnoverRow from '../components/TurnoverRow'
// import DatePicker from 'react-datepicker2';
import moment from 'moment-jalaali'
import watermark from '../assets/watermark.png'
import portfolioicon from '../assets/portfolioicon.png'
import portfolioiconwhite from '../assets/portfolioiconwhite.png'
import piechartwhite from '../assets/piechartwhite.png'
import linearchartwhite from '../assets/linearchartwhite.png'
import exportexcel from '../assets/exportexcel.png'
import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import { AgGridReact } from 'ag-grid-react';
import { MagicSpinner } from "react-spinners-kit";
import piechart from '../assets/piechart.png'
import linearchart from '../assets/linearchart.png'
// import { DatePicker  } from "jalali-react-datepicker";

// import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
// import Calendar from '@hassanmojab/react-modern-calendar-datepicker';
// import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';

import DatePicker, { DateObject } from "react-multi-date-picker"
// import Toolbar from "react-multi-date-picker/plugins/toolbar"
import "react-multi-date-picker/styles/layouts/mobile.css"
import "react-multi-date-picker/styles/layouts/prime.css"
import "react-multi-date-picker/styles/colors/bluee.css"


export default class DashboardContent extends Component {
    constructor(props){
        super(props);
        
        this.state = {
            firstPageDisable:false,
            prePageDisable:false,
            nextPageDisable:false,
            lastPageDisable:false,
            ModalShow:false,
            currentPage:'1',
            lastPage:'1',
            paginationText:'',
            filterContainer:false,
            currentReportType:'last',
            dateValue: moment().format('jYYYY/jMM/jDD'),
            // dateValue: '',
            dateValue1: moment().add(-1,'months'),
            maxDate: moment().add(0,'days').format('jYYYY/jMM/jDD'),
            // maxDate: '1400/02/25',
            // maxDateStart: moment().add(-1,'days'),
            // minDate:'today',
            // minDate:'1400/02/13',
            columnDefs1: [{
                headerName: "نماد", field: "symbol",sortable:true,filter:false,resizable: true,valueFormatter:this.formatContent,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "تعداد", field: "quantity",sortable: true,filter:false,resizable: true,valueFormatter:this.numberWithCommas,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            },{
                headerName: "بهای تمام شده", field: "break",sortable: true,filter:false,valueFormatter: this.numberWithCommas,resizable: true,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "بهای تمام شده کل", field: "cost",sortable: true,filter:false,valueFormatter: this.numberWithCommas,resizable: true,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "ارزش روز", field: "price",cellRenderer:'fotmatProfitPercent',sortable: true,filter:false,valueFormatter: this.numberWithCommas,resizable: true,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true,minWidth:160
            }, {
                headerName: "ارزش کل", field: "total_price",sortable: true,filter:false,valueFormatter: this.numberWithCommas,resizable: true,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "سود یا زیان", field: "benefit",sortable: true,filter:false,valueFormatter: this.numberWithCommas,resizable: true,cellStyle: params => params.value!==null && params.value < 0 ? {color:'#ed2f59',display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'} : {color:'#35d494',display:'flex',justifyContent:'center',alignItems:'center',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "درصد سود یا زیان", field: "benefit_percent",sortable: true,filter:false,valueFormatter: this.numberWithPercent,resizable: true,cellStyle: params => params.value!==null && params.value < 0 ? {color:'#ed2f59',display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'} : {color:'#35d494',display:'flex',justifyContent:'center',alignItems:'center',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "درصد (بهای تمام شده)", field: "cost_percent",sortable: true,filter:false,valueFormatter: this.numberWithPercent,resizable: true,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "درصد (ارزش روز)", field: "price_percent",sortable: true,filter:false,valueFormatter: this.numberWithPercent,resizable: true,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true,sort:'desc'
            }],
            columnDefs2: [{
                headerName: "نماد", field: "symbol",sortable:true,filter:false,resizable: true,valueFormatter:this.formatContent,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "تعداد", field: "quantity",sortable: true,filter:false,resizable: true,valueFormatter:this.numberWithCommas,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            },{
                headerName: "بهای تمام شده", field: "break",sortable: true,filter:false,valueFormatter: this.numberWithCommas,resizable: true,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "بهای تمام شده کل", field: "cost",sortable: true,filter:false,valueFormatter: this.numberWithCommas,resizable: true,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "ارزش روز", field: "price",sortable: true,filter:false,valueFormatter: this.numberWithCommas,resizable: true,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "ارزش فعلی", field: "todayPrice",sortable: true,filter:false,valueFormatter: this.numberWithCommas,resizable: true,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "ارزش کل", field: "total_price",sortable: true,filter:false,valueFormatter: this.numberWithCommas,resizable: true,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "سود یا زیان", field: "benefit",sortable: true,filter:false,valueFormatter: this.numberWithCommas,resizable: true,cellStyle: params => params.value!==null && params.value < 0 ? {color:'#ed2f59',display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'} : {color:'#35d494',display:'flex',justifyContent:'center',alignItems:'center',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "درصد سود یا زیان", field: "benefit_percent",cellRenderer:'fotmatProfitPercent',sortable: true,filter:false,valueFormatter: this.numberWithPercent,resizable: true,cellStyle: params => params.value!==null && params.value < 0 ? {color:'#ed2f59',display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'} : params.value!==null && params.value > 0 ? {color:'#35d494',display:'flex',justifyContent:'center',alignItems:'center',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}:{color:'black',display:'flex',justifyContent:'center',alignItems:'center',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "درصد (بهای تمام شده)", field: "cost_percent",sortable: true,filter:false,valueFormatter: this.numberWithPercent,resizable: true,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true
            }, {
                headerName: "درصد (ارزش روز)", field: "price_percent",sortable: true,filter:false,valueFormatter: this.numberWithPercent,resizable: true,cellStyle:{display:'flex',justifyContent:'center',alignItems:'center',borderStyle:'solid',borderWidth:'0px 1px 0px 0px',borderColor:'var(--gray6)'}, lockPosition: true,sort:'desc'
            }],
            columnDefs:[],
            frameworkComponents:{
                fotmatProfitPercent:this.fotmatProfitPercent,
            },
            chartData:[],
            isLoading:false,
            buttonDisabled:false,
            showTable:true,
            showPieChart:false,
            sowLineChart:false,
        };

        this.accordionOpenBuySell = this.accordionOpenBuySell.bind(this);
        this.accordionOpenInOut = this.accordionOpenInOut.bind(this);
        this.updatePagination = this.updatePagination.bind(this);
        this.exportExcelIsDone = this.exportExcelIsDone.bind(this);
        this.potfolioExportClicked = this.potfolioExportClicked.bind(this);
        this.fitSizeTable = this.fitSizeTable.bind(this);
        this.fixNumber = this.fixNumber.bind(this);
        // this.testtt = this.testtt.bind(this);

        this.tableGrid=React.createRef();
        this.reportTypeSwitch=React.createRef();
        this.excelButton=React.createRef();
        this.datepickerr=React.createRef();

        // this.setState({columnDefs:this.state.columnDefs1})
    }

    fotmatProfitPercent(params){
            // let formattedValue="-";
            // if (params.value!==null && params.value>0){
            //     formattedValue = params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            // }
            // console.log(params);
            // let value=0;
            // if (params.value!==null && params.value!=='null' && params.value!==undefined) params.value="0";
            let formattedValue="";
            if (params.value!==null && params.value!=='null' && params.value!==undefined && params.value!==''){
                formattedValue = params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            return <div style={{flex:'1',display:'flex',flexDirection:'row-reverse',width:'100%',justifyContent:'space-between'}}>
                {(params.value==='null' || params.value==='' || params.value===null) && <div style={{flex:'1',textAlign:'center',color:'black'}} >-</div>}
                {params.value!=='null' && params.value!=='' && params.value!==null && params.value!==0 && <div style={{flex:'1',textAlign:params.data.change_percent!==undefined?'right':'center'}} >{formattedValue}</div>}
                {params.value!=='null' && params.value!=='' && params.value!==null && params.value===0 && <div style={{flex:'1',textAlign:params.data.change_percent!==undefined?'right':'center'}} >-</div>}
                {params.data.change_percent!==undefined && <div style={{minWidth:'10px'}} />}
                {params.data.change_percent!==undefined && params.data.change_percent!==0 && <div style={{flex:'1',display:'flex',flexDirection:'row',textAlign:'right',color:params.data.change_percent>0?'#35d494':'#ed2f59',fontSize:'12px'}}>(&nbsp;%&nbsp;{params.data.change_percent})</div>}
                {/* {params.data.change_percent<0 && <div style={{color:'#ed2f59',fontSize:'11px',margin:'0px 2px'}}><FontAwesomeIcon icon={faLongArrowAltDown} /></div>}{params.data.change_percent>0 && <div style={{color:'#35d494',fontSize:'11px',margin:'0px 2px'}}><FontAwesomeIcon icon={faLongArrowAltUp} /></div>} */}
                {params.data.change_percent!==undefined && params.data.change_percent===0 && <div style={{flex:'1',display:'flex',flexDirection:'row',textAlign:'center',color:'black',fontSize:'10px',justifyContent:'center',alignItems:'center'}}>-</div>}
            </div>
    }

    convertDate(date){
        let timee = new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit'}).formatToParts(date)
        let year='';
        let month='';
        let day='';
        timee.forEach(element => {
            if (element.type==='year'){
                year=element.value;
            }else if (element.type==='month'){
                month=element.value;
            }else if (element.type==='day'){
                day=element.value;
            }
        });
        let formatedDate=year+'/'+month+'/'+day;
        let pdate=moment(formatedDate, 'YYYY/MM/DD').format('jYYYY-jMM-jDD');
        return pdate;
    }
    
    numberWithCommas(params) {
        try {
            if (params.value==='null' || params.value==='') return '-';
            return params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } catch (error) {
            return "-";
        }
    }

    numberWithPercent(params) {
        try{
            if (params.value==='null' || params.value==='' || params.value===null) return '-';
            return " % "+params.value;
        }catch(error){
            return "-";
        }
    }

    formatContent(params){
        try{
            if (params.value==='null' || params.value==='' || params.value==='0' || params.value===0 || params.value===null) return '-';
            else return params.value;
        }catch(error){
            return '-'
        }
    }

    componentDidMount(){
        this.props.pageIsopen();
    }

    onGridReady(){
        try {
            this.updatePagination();
            this.fitSizeTable();

        } catch (error) {
            // alert(error.message)
        }
    }

    fitSizeTable(){
        var allColumnIds = [];
        this.tableGrid.current.columnApi.getAllColumns().forEach(function(column) {
            allColumnIds.push(column.colId);
        });
        this.tableGrid.current.columnApi.autoSizeColumns(allColumnIds,false);

        // this.tableGrid.current.api.sizeColumnsToFit();
    }

    reportTypeChanged(){
        if (this.reportTypeSwitch.current.checked){
            this.setState({currentReportType:'end'})
            this.props.onChangeType(this.props.portfolioID,'end',false);
        }else{
            this.setState({currentReportType:'last'})
            this.props.onChangeType(this.props.portfolioID,'last',false);
        }
    }

    filterClicked(){
        if (this.state.filterContainer){
            this.setState({filterContainer:false})
        }else{
            this.setState({filterContainer:true})
        }
    }

    fixNumber(str){
        var persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers  = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
        if(typeof str === 'string')
        {
            for(var i=0; i<10; i++)
            {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }

    dateChange(dateValue){
        console.log('====================================');
        console.log(dateValue);
        console.log('====================================');
        this.datepickerr.current.closeCalendar();
        let value=this.fixNumber(new DateObject(dateValue).format('YYYY/MM/DD'))
        
        if (this.state.dateValue!==value){
            this.setState({ dateValue: value})
            if (value===moment().format('jYYYY/jMM/jDD')){
                this.setState({columnDefs:this.state.columnDefs1},()=>{
                    this.props.filterPortfolio('today',moment().format('jYYYY-jMM-jDD'));
                })
            }else{
                this.setState({columnDefs:this.state.columnDefs2},()=>{
                    this.props.filterPortfolio(this.fixNumber(new DateObject(dateValue).format('YYYY-MM-DD')),moment().format('jYYYY-jMM-jDD'));
                })
            }
        }
    }

    accordionOpenBuySell(){
        this.props.accordionOpen('buysell')
    }

    accordionOpenInOut(){
        this.props.accordionOpen('inout')
    }

    accordionOpenExcel(){
        this.props.accordionOpen('excel')
    }

    potfolioExportClicked(){
        this.setState({buttonDisabled:true})
        this.props.ExportExcel();
    }

    setLoadingOn(){
        this.setState({isLoading:true})
    }

    setLoadingOff(){
        this.setState({isLoading:false})
    }

    updatePagination(){
        try {
            this.setState({lastPage:this.tableGrid.current.api.paginationGetTotalPages(),currentPage:this.tableGrid.current.api.paginationGetCurrentPage()+1},()=>{
                this.setState({paginationText:this.state.currentPage+" از " + this.state.lastPage})
                if (this.state.lastPage===1){
                    this.setState({firstPageDisable:true,prePageDisable:true,nextPageDisable:true,lastPageDisable:true});
                    return;
                }

                if (this.state.currentPage===1) {this.setState({firstPageDisable:true,prePageDisable:true,nextPageDisable:false,lastPageDisable:false}); return;}

                if (this.state.currentPage===this.state.lastPage) {this.setState({firstPageDisable:false,prePageDisable:false,nextPageDisable:true,lastPageDisable:true}); return;}
                
                if (this.state.currentPage>1) this.setState({firstPageDisable:false,prePageDisable:false,nextPageDisable:false,lastPageDisable:false})
            });
        } catch (error) {
            
        }
    }

    firstPageClicked(){
        this.tableGrid.current.api.paginationGoToFirstPage();
        this.updatePagination();
    }

    prePageClicked(){
        this.tableGrid.current.api.paginationGoToPreviousPage();
        this.updatePagination();
    }

    nextPageClicked(){
        this.tableGrid.current.api.paginationGoToNextPage();
        this.updatePagination();
    }

    lastPageClicked(){
        this.tableGrid.current.api.paginationGoToLastPage();
        this.updatePagination();
    }

    exportExcelIsDone(){
        this.setState({buttonDisabled:false})
    }

    onGridRowClicked(e){
        this.props.OpenBuySellWithSymbol(e.data.symbol,e.data.symbol_id)
    }

    showTable(){
        if (!this.state.showTable){
            this.setState({showTable:true,showPieChart:false,showLineChart:false})
        }
    }

    showPieChart(){
        if (!this.state.showPieChart){
            this.setState({showTable:false,showPieChart:true,showLineChart:false})
        }
    }

    showLineChart(){
        if (!this.state.showLineChart){
            this.setState({showTable:false,showPieChart:false,showLineChart:true})
        }
    }

    showDatePicker(){

    }

    render() {
        return (
            <div ref={this.tabcontainer} className={this.props.tabselectedindex===0 ? "tabsContainer rmvStartRadius":"tabsContainer"}>
                <div className="tabsAllContent">
                    <div ref={this.tabcontent} className={this.props.portfolioData.length===0 ? "tabsContent tabsContentMax":"tabsContent"} >
                        {(this.props.portfolioData.length>0 || this.props.hasTransaction) && this.props.pageWidth>=768 && <div className="tabsContentHeader">
                            <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',fontSize:'12px',color:'var(--gray4)'}}>
                                <img src={portfolioicon} style={{height:'20px',marginLeft:'10px'}} alt="portfolio"/>
                                <div>پرتفوی</div>
                            </div>
                            <div style={{display:'flex',flexDirection:'row-reverse',alignItems:'center',flexWrap:'wrap',flex:'1'}} >
                                <Button variant="secondary" className="filterButton" disabled={this.state.buttonDisabled} onClick={this.potfolioExportClicked}><div style={{display:'flex',flexDirection:'row-reverse',justifyContent:'center',alignItems:'center'}}>{this.state.buttonDisabled && <Spinner className="spinnerStyle" animation="border" />}{!this.state.buttonDisabled && <div style={{flexDirection:'row',display:'flex'}}><div style={{marginLeft:'10px',height:'100%', paddingTop:'4px'}}>فایل اکسل</div><Image style={{height:'16px'}} src={exportexcel} /></div>}</div></Button>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',fontSize:'12px'}}>
                                    <div style={{margin:'2px 10px 0px 10px',whiteSpace:'nowrap'}}>آخرین قیمت</div>
                                    <SwitchComponent checked={false} cssClass='bar-color' ref={this.reportTypeSwitch} change={this.reportTypeChanged.bind(this)}/>
                                    <div style={{margin:'2px 10px 0px 10px',whiteSpace:'nowrap'}}>قیمت پایانی</div>

                                    <div style={{margin:'0px 10px',display:'flex',flexDirection:'row',alignItems:'center'}}>
                                        <div style={{margin:'0px 5px',whiteSpace:'nowrap'}}>تاریخ:</div>
                                        {/* <DatePicker
                                            min={this.state.minDate}
                                            max={this.state.maxDate}
                                            className="form-control inputStyleFilter"
                                            timePicker={false}
                                            isGregorian={false}
                                            ref={(scope) => this.datepickerr = scope}
                                            onChange={valuee => this.dateChange(valuee)}
                                            value={this.state.dateValue}
                                            style={{zIndex:'3 !important'}}
                                        /> */}

                                        <DatePicker
                                            ref={this.datepickerr}
                                            value={this.state.dateValue}
                                            inputClass="form-control inputStyleFilter"
                                            calendar="persian"
                                            locale="fa"
                                            weekDays={[
                                                "ش", 
                                                "ی", 
                                                "د", 
                                                "س", 
                                                "چ", 
                                                "پ", 
                                                "ج"
                                            ]}
                                            format="YYYY/MM/DD"
                                            animation
                                            className="bluee"
                                            onChange={valuee => this.dateChange(valuee)}
                                            maxDate={this.state.maxDate}
                                            editable={false}
                                            inputMode="none"
                                            placeholder="انتخاب"
                                            // plugins={[
                                            //     <Toolbar
                                            //         position="bottom"
                                            //         sort={["today"]}
                                            //     />
                                            // ]}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>}

                        {(this.props.portfolioData.length>0 || this.props.hasTransaction) && this.props.pageWidth<768 && <div className="tabsContentHeaderSmall">
                            <div className="tabsContentHeaderChild1">
                                <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',fontSize:'12px',color:'var(--gray4)'}}>
                                    <img src={portfolioicon} style={{height:'20px',marginLeft:'10px'}} alt="portfolio"/>
                                    <div>پرتفوی</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                    <div style={{marginLeft:'5px',whiteSpace:'nowrap'}}>آخرین</div>
                                    <SwitchComponent checked={false} cssClass='bar-color' ref={this.reportTypeSwitch} change={this.reportTypeChanged.bind(this)}/>
                                    <div style={{margin:'0px 5px',whiteSpace:'nowrap'}}>پایانی</div>
                                </div>
                                <Button variant="secondary" className="filterButton" disabled={this.state.buttonDisabled} onClick={this.potfolioExportClicked}><div style={{display:'flex',flexDirection:'row-reverse',justifyContent:'center',alignItems:'center'}}>{this.state.buttonDisabled && <Spinner className="spinnerStyle" animation="border" />}{!this.state.buttonDisabled && <div style={{flexDirection:'row',display:'flex'}}><Image style={{height:'16px'}} src={exportexcel} /></div>}</div></Button>
                            </div>
                            
                            <div className="tabsContentHeaderChild2">
                                <div className="tabsContentHeaderChild2" style={{justifyContent:'flex-start',width:'fit-content'}}>
                                    <div className={!this.state.showTable?"portfolioShowTypeButton":"portfolioShowTypeButton portfolioShowTypeButtonSelected"} onClick={this.showTable.bind(this)}>
                                        <img  src={this.state.showTable? portfolioiconwhite:portfolioicon} alt="piechart" style={{height:'16px'}}/>
                                    </div>
                                    <div className={!this.state.showPieChart?"portfolioShowTypeButton":"portfolioShowTypeButton portfolioShowTypeButtonSelected"} onClick={this.showPieChart.bind(this)}>
                                        <img  src={this.state.showPieChart?piechartwhite:piechart} alt="piechart" style={{height:'16px'}}/>
                                    </div>
                                    <div className={!this.state.showLineChart?"portfolioShowTypeButton":"portfolioShowTypeButton portfolioShowTypeButtonSelected"} onClick={this.showLineChart.bind(this)}>
                                        <img  src={this.state.showLineChart?linearchartwhite:linearchart} alt="piechart" style={{height:'16px'}}/>
                                    </div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                        <div style={{margin:'0px 5px',whiteSpace:'nowrap'}}>تاریخ:</div>
                                        {/* <DatePicker
                                            min={this.state.minDate}
                                            max={this.state.maxDate}
                                            className="form-control inputStyleFilter"
                                            timePicker={false}
                                            isGregorian={false}
                                            ref={(scope) => this.datepickerr = scope}
                                            onChange={valuee => this.dateChange(valuee)}
                                            value={this.state.dateValue}
                                            style={{zIndex:'3 !important',marginRight:'0'}}
                                        /> */}


                                        <DatePicker
                                            ref={this.datepickerr}
                                            value={this.state.dateValue}
                                            inputClass="form-control inputStyleFilter"
                                            calendar="persian"
                                            locale="fa"
                                            weekDays={[
                                                "ش", 
                                                "ی", 
                                                "د", 
                                                "س", 
                                                "چ", 
                                                "پ", 
                                                "ج"
                                            ]}
                                            format="YYYY/MM/DD"
                                            animation
                                            className="rmdp-mobile bluee"
                                            onChange={valuee => this.dateChange(valuee)}
                                            maxDate={this.state.maxDate}
                                            editable={false}
                                            inputMode="none"
                                            placeholder="انتخاب"
                                            // plugins={[
                                            //     <Toolbar
                                            //         position="bottom"
                                            //         sort={["today"]}
                                            //     />
                                            // ]}
                                        />
                                        
                                </div>
                            </div>

                            
                        </div>}


                        {this.props.portfolioData.length>0 && this.props.pageWidth>=768 && !this.state.isLoading && <div className="ag-theme-alpine" style={{direction:'rtl',width:'100%',height:'100%',display:'flex',flexDirection:'column',overflow:'auto'}}>
                            <AgGridReact
                                enableRtl={true}
                                autoHeight={true}
                                animateRows={true}
                                enableCharts={true}
                                enableBrowserTooltips={true}
                                tooltipMouseTrack={true}
                                suppressSizeToFit={false}
                                columnDefs={this.state.columnDefs.length===0 ? this.state.columnDefs1:this.state.columnDefs}
                                localeText={this.props.gridLocaleText}
                                rowData={this.props.portfolioData}
                                suppressDragLeaveHidesColumns ={true}
                                suppressMovable={true}
                                onGridReady={this.onGridReady.bind(this)}
                                rowHeight={24}
                                headerHeight={35}
                                frameworkComponents={this.state.frameworkComponents}
                                onRowClicked={this.onGridRowClicked.bind(this)}
                                getRowStyle ={function(params){ return { borderWidth:'0px' }}}
                                ref={this.tableGrid}>
                            </AgGridReact>
                        </div>}
                        {this.props.portfolioData.length>0 && this.props.pageWidth<768 && this.state.showTable && !this.state.isLoading && 
                        <div className="portfolioContainer">
                            <div style={{width:'100%',height:'1px',backgroundColor:'var(--gray3)'}} />
                            {this.props.portfolioData.map(item=>(
                                <PortfolioRow onItemClicked={this.onGridRowClicked.bind(this,{data:{symbol:item.symbol,symbol_id:item.symbol_id}})} key={item.id} symbol={item.symbol} quantity={item.quantity} price={item.price} change_percent={item.change_percent} total_price={item.total_price} price_percent={item.price_percent} benefit={item.benefit} break={item.break} cost={item.cost} benefit_percent={item.benefit_percent} />
                            ))}
                        </div>}

                        {this.props.portfolioData.length>0 && this.props.pageWidth<768 && this.state.showPieChart && !this.state.isLoading && 
                        <div className="portfolioContainer">
                            <div style={{width:'100%',height:'1px',borderTop:'1px solid var(--gray3)'}} />
                            {this.props.portfolioData.length>0 && <Chart type="pie" chartName="chart2" title="نمودار درصد پرتفوی" data={this.props.portfolioData} basedOn={this.props.portfolioBasedOnData} />}
                            <div style={{width:'100%',height:'1px',borderTop:'1px solid var(--gray3)'}} />
                            {this.props.industryData.length>0 && <Chart type="pie" chartName="chart1" title="نمودار درصد پرتفوی بر اساس صنعت" data={this.props.industryData} basedOn={this.props.industryBasedOnData} />}
                        </div>}


                        {this.props.portfolioData.length>0 && this.props.pageWidth<768 && this.state.showLineChart && !this.state.isLoading && 
                        <div className="portfolioContainer" style={{direction:'ltr'}}>
                            <div style={{width:'100%',height:'1px',backgroundColor:'var(--gray3)'}} />
                            <Chart type="bar" chartName="chart3" title="خلاصه عملکرد پرتفوی" data={this.props.chart3Data}/>
                        </div>}


                        {this.props.portfolioData.length===0 && !this.props.hasTransaction && !this.state.isLoading &&
                        <div style={{display:'flex',flexDirection:'column',flex:'1',justifyContent:'center',alignItems:'center',textAlign:'center',color:'var(--gray4)'}}>
                            <img src={watermark} alt="watermark" style={{marginBottom:'20px',width:'70%',maxWidth:'350px',minWidth:'100px'}}/>
                            سبد خالی است
                            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',minWidth:'100px',width:'fit-content',maxWidth:'350px',marginTop:'20px',minHeight:'32px'}}>
                                <Button onClick={this.accordionOpenInOut.bind(this)} className="nothingButton" style={{marginRight:'0'}}>ثبت واریز و برداشت جدید</Button>
                                <Button onClick={this.accordionOpenBuySell.bind(this)} className="nothingButton" style={{marginLeft:'0'}}>ثبت خرید و فروش جدید</Button>
                            </div>
                            <div style={{display:'flex',flexDirection:'row',justifyContent:'center',minWidth:'100px',width:'fit-content',maxWidth:'350px',marginTop:'20px',minHeight:'32px'}}>
                                <Button variant="secondary" onClick={this.accordionOpenExcel.bind(this)} className="nothingButton">ورود اطلاعات اکسل</Button>
                            </div>
                        </div>}

                        {this.props.portfolioData.length===0 && this.props.hasTransaction && !this.state.isLoading &&
                        <div style={{display:'flex',flexDirection:'column',flex:'1',justifyContent:'center',alignItems:'center',textAlign:'center',color:'var(--gray1)',fontSize:'14px'}}>
                            در تاریخ مورد نظر هیچ موردی یافت نشد
                        </div>}

                        {this.state.isLoading && <div className="loading-inside">
                                <MagicSpinner size={70} color="var(--green1)" loading={true} />
                                <div style={{marginTop:'14px'}}>لطفاً شکیبا باشید</div>
                        </div>}
                    </div>

                    {this.props.portfolioData.length>0 && this.props.pageWidth>=768 && <div className="dashCharts">
                        {this.props.portfolioData.length>0 && <Chart type="pie" chartName="chart2" title="نمودار درصد پرتفوی" data={this.props.portfolioData} basedOn={this.props.portfolioBasedOnData} />}
                        {this.props.industryData.length>0 && <Chart type="pie" chartName="chart1" title="نمودار درصد پرتفوی بر اساس صنعت" data={this.props.industryData} basedOn={this.props.industryBasedOnData} />}
                        <Chart type="bar" chartName="chart3" title="خلاصه عملکرد پرتفوی" data={this.props.chart3Data}/>
                    </div>}
                </div>
            </div>
        )
    }
}
